import { Injectable, TemplateRef } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { filterDefined } from 'utils/is-defined';

import { TemplateContext } from './model/template-context.interface';
import { DynamicFormTemplateDirective } from './template.directive';

@Injectable()
export class TemplateService {
  private readonly templatesRegisterSubject: BehaviorSubject<
    Map<string, TemplateRef<TemplateContext>>
  > = new BehaviorSubject(new Map());

  getTemplateByName$(name: string): Observable<TemplateRef<TemplateContext>> {
    return this.templatesRegisterSubject.pipe(
      map(mapObject => mapObject.get(name)),
      filterDefined(),
      distinctUntilChanged(),
    );
  }

  register(templates: DynamicFormTemplateDirective[]): void {
    const newTemplates = new Map(
      templates.map(template => [template.name, template.templateRef]),
    );
    this.templatesRegisterSubject.next(
      new Map(
        [...this.templatesRegisterSubject.value].concat([...newTemplates]),
      ),
    );
  }
}
